import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ParticipantForm from '@/components/registration/ParticipantForm';
import RegistrationFooter from '@/components/registration/RegistrationFooter';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';

const RegisterParticipant = () => {
  return <div className="flex min-h-screen flex-col relative">
    <div className="absolute inset-0 z-0">
      <img
        src={Gradient}
        alt="MediHub háttér"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/30 z-0"></div>
    </div>
    <Navbar />
    <div className="flex-1 py-6 mt-32 relative z-10">
      <div className="container max-w-3xl mx-auto px-4">
        <div className="space-y-1 pb-4">
          <h2 className="text-3xl text-center text-white font-semibold">Egészségügyi dolgozó regisztráció</h2>
          <p className="text-center text-white">
            Hozzon létre egy egészségügyi dolgozói fiókot
          </p>
        </div>
        <Card className="overflow-hidden">
          <CardContent className="py-8">
            <ParticipantForm />
          </CardContent>
          <CardFooter className="flex flex-col gap-2 pt-0">
            <RegistrationFooter type="participant" />
          </CardFooter>
        </Card>
      </div>
    </div>
    <Footer />
  </div>;
};

export default RegisterParticipant;
